import { EventQuery } from "lib/build/events";

export const queries: { [key: string]: EventQuery } = {
	status: {
		interpretation: { vocab: "ltx", code: "patient_status" }
	},
	address: {
		interpretation: { vocab: "snomed", code: "184097001" }
	},
	weight: {
		interpretation: { vocab: "ltx", code: "weight" }
	},
	ab0: {
		interpretation: { vocab: "ltx", code: "ab0" }
	},
	rh: {
		interpretation: { vocab: "ltx", code: "rh" }
	},
	waitingListStartDate: {
		interpretation: { vocab: "ltx", code: "waiting_list_start_date" }
	},
	urgency: {
		interpretation: { vocab: "ltx", code: "urgency" }
	},
	combinedTransplant: {
		interpretation: { vocab: "ltx", code: "combined_transplant" }
	}
};
